import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import { mapActions, mapMutations, mapState } from 'vuex';
import { previewMixin } from '../mixin/preview.js';
import { gameConfigCategoryResourceType, i18nCategoryResourceType } from '@/store/creative/common/category';

export default {
  mixins: [previewMixin],

  props: {
    category: {
      type: Object,
      required: true
    },

    index: {
      type: Number,
      required: true
    },

    configList: {
      type: Array,
      required: true
    },

    isDefault: {
      type: Boolean,
      default: false
    }
  },

  computed: _extends({}, mapState({
    groupsConfig: function groupsConfig(state) {
      return state.creative.template.groupsConfig || [];
    }
  })),

  methods: _extends({}, mapMutations({
    removeI18nResource: 'creative/template/removeI18nResource',
    removeCategoryGameConfigResource: 'creative/template/removeCategoryGameConfigResource',
    updatePreviewGroupConfig: 'creative/template/updatePreviewGroupConfig'
  }), mapActions({
    rebuildCategory: 'creative/template/rebuildCategory',
    updateGroupsConfig: 'creative/template/updateGroupsConfig'
  }), {
    remove: function remove() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // 删除当前坑位资源时跳转至第一个组合
                if (_this.isDefault) {
                  _this.updatePreviewGroupConfig(_this.groupsConfig[0].name);
                }

                if (!(_this.category.resource_type === i18nCategoryResourceType)) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return _this.removeI18n();

              case 4:
                if (!(_this.category.resource_type === gameConfigCategoryResourceType)) {
                  _context.next = 7;
                  break;
                }

                _context.next = 7;
                return _this.removeGameConfig();

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    removeI18n: function removeI18n() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.removeI18nResource({
                  category: _this2.category,
                  index: _this2.index
                });
                _context2.next = 3;
                return _this2.rebuildCategory();

              case 3:
                _context2.next = 5;
                return _this2.updateGroupsConfig();

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    removeGameConfig: function removeGameConfig() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.removeCategoryGameConfigResource({
                  category: _this3.category,
                  index: _this3.index
                });
                _context3.next = 3;
                return _this3.rebuildCategory();

              case 3:
                _context3.next = 5;
                return _this3.updateGroupsConfig();

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  })
};